import useGetListFilePartsAndDownload from 'Components/SidePanel/hooks/useGetListFilePartsAndDownload';
import { useListFilesDownloadStore } from 'Hooks/zustand/useListFilesDownloadStore';
import React from 'react';

type ListFileDownloadManagerProps = {
    fileToDownload: ListFileDownloadData;
};

const ListFileDownloadManager = ({ fileToDownload }: ListFileDownloadManagerProps) => {
    const { removeFileFromDownloading } = useListFilesDownloadStore();
    const downloadHook = useGetListFilePartsAndDownload(fileToDownload.id);
    // Download should only be initiated once when mounted
    React.useEffect(() => {
        downloadHook.initiateListFileDownload(fileToDownload.currentFileName, fileToDownload.processType);
        return () => {
            // clean itself if user/rule-set/app-scope has changed/refreshed since lists are not shared.
            removeFileFromDownloading(fileToDownload.id);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <></>;
};

export default ListFileDownloadManager;
